<template>
  <div class="baseCard">
    <Lunbo node="zyfw_lbt"></Lunbo>

    <div class="volMain">
      <tabLan
        :tabList="tabList"
        @setIndex="tabMenu"
      ></tabLan>
      <div
        class="vlContent"
        v-show="index==0"
      >
        <div
          class="volItem"
          @click="$jumpTo('/serverDetail',{id:item.id,type:'fw'})"
          v-for="(item,index) in serveData"
          :key="index"
        >
          <img
            :src="item.smallImage"
            alt=""
          >
          <div class="volItemInfo">
            <p class="volLine1"></p>
            <p class="volLine2"></p>
            <p class="volItemTitle">{{item.title}}</p>
            <div class="volItemIntro">{{item.metaDescription}}</div>
            <div class="volBottom">
              <div class="volDate">
                <p>
                  <i class="iconfont">&#xe647;</i>
                  <span style="margin-left:10px">发布时间：{{item.publishDate}}</span>
                </p>
                <p style="margin-left:50px">
                  <i class="iconfont">&#xe601;</i>
                  <span style="margin-left:10px">浏览量：{{item.views}}</span>
                </p>
              </div>
              <div class="volShare">
                <i class="iconfont">&#xe76d;</i>
                <p style="margin-top: 5px;">分享：</p>
                <img
                  src="../../assets/img/qq.png"
                  alt=""
                >
                <img
                  src="../../assets/img/weibo.png"
                  alt=""
                >
                <img
                  src="../../assets/img/weixin.png"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="vlContent"
        v-show="index==1"
      >
        <ul class="workList">
          <li>
            <div
              class="workListLi"
              v-for="(item,index) in serveData"
              :key="index"
              @click="$jumpTo('/serverDetail',{id:item.id,type:'work'})"
            >
              <div class="workListLiTop">
                <p>{{item.title}}</p>
                <span>》</span>
              </div>
              <p class="time">{{item.publishDate}}</p>
            </div>
          </li>
        </ul>
        <a-pagination
          v-model="page"
          :total="total"
          @change="changePage"
          show-less-items
        />
      </div>
      <div
        class="videoContent"
        v-show="index==2"
      >
        <div
          class="videoItem"
          v-for="item in serveData"
          :key="item.id"
          @click="$jumpTo('/videoPlay',{video:item.video})"
        >
          <img style="width:100%;height:250px" :src="item.smallImage" alt="">
          <p>{{item.title}}</p>
          <div class="videoItemInfo"><span>{{item.publishDate}}</span>
            <p>
              <i class="iconfont">&#xe601;</i>
              <span style="margin-left:10px">浏览量：{{item.views}}</span>
            </p>
          </div>
        </div>
      </div>
       <div
        class="videoContent"
        v-show="index==3"
      >
      <div class="zyz-recruiting">
        <div class="recruiting">
          <a :href=dataA.linkadd class="recruiting-a" target="_blank">
            <div>日常招募</div>
          </a>
        </div>
        <div class="recruiting">
          <a :href=dataAdd.linkadd class="recruiting-aa" target="_blank">
            <div>品牌招募</div>
          </a>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiUrls from "@api";
import tabLan from "@components/tabLan";
import Lunbo from "@components/Lunbo";
export default {
  data() {
    return {
      tabList: [
        {
          text: "服务工作",
        },
        {
          text: "工作动态",
        },
        {
          text: "活动视频",
        },
        {
          text: "志愿者招募",
        },
      ],
      index: 0,
      data: [],
      dataA:[],
      dataAdd:[],
      page: 1,
      size: 15,
      total: 0,
      serveData: [],
      node: "zyfw_fwgz",
    };
  },

  components: {
    tabLan,
    Lunbo,
  },

  mounted() {
    this.getServer();
    this.getDataA();
    this.getDataAdd();
  },

  methods: {
    changePage(val){
      this.page=val
      this.getServer();
    },
    tabMenu(index) {
      this.page = 0;
      this.size = 15;
      this.total = 0;
      this.index = index;
      if (index == 0) {
        this.node = "zyfw_fwgz";
      } else if (index == 1) {
        this.node = "zyfw_gzdt";
      } else {
        this.node = "zyfw_hdsp";
      }
      this.getServer();
    },
    getServer() {
      apiUrls
        .getList({
          node: this.node,
          page: this.page - 1,
          size: this.size,
        })
        .then((res) => {
          this.serveData = res.results.data;
          this.total = res.results.pager.totalElements;
        });
    },
    //志愿者招募
    getDataA() {
      apiUrls.getNode({ node: "zyfw_rczm" }).then((res) => {
        this.dataA = res.results.data;
        console.log(this.dataA);
      });
    },
    getDataAdd() {
      apiUrls.getNode({ node: "zyfw_ppzm" }).then((res) => {
        this.dataAdd = res.results.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.volMain {
  width: 100%;
  margin-top: 20px;
  .vlContent {
    width: 100%;
    border: 1px solid #d8d8d8;
    margin-top: 20px;
    padding: 20px;

    .volItem {
      width: 100%;
      height: 164px;
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;
      border-bottom: 1px dotted #d8d8d8;
      margin-bottom: 20px;
      cursor: pointer;
      img {
        width: 208px;
        height: 144px;
        margin-right: 20px;
      }
      .volItemInfo {
        width: calc(100% - 230px);
        position: relative;
        .volLine1 {
          width: 23px;
          height: 5px;
          background: #d82a2a;
          border-radius: 3px;
        }
        .volLine2 {
          position: absolute;
          width: 23px;
          height: 5px;
          background: #d82a2a;
          border-radius: 3px;
          opacity: 0.39;
          left: 15px;
          top: 0px;
        }
        .volItemTitle {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          margin: 10px 0px;
        }
        .volItemIntro {
          font-size: 14px;
          color: #333333;
        }
        .volBottom {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          .volDate {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
              color: #919191;

              font-size: 12px;
            }
          }
          .volShare {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              margin: 0px 2px;
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
    .workList {
      width: 100%;
      li {
        display: inline-block;
        width: 100%;
        list-style: none;

        .workListLi {
          display: flex;
          flex-direction: column;
          margin: 10px 0px;
          cursor: pointer;
          padding-bottom: 10px;
          border-bottom: 1px dotted #d8d8d8;
          .workListLiTop {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            font-family: "MicrosoftYaHeiUI";
            color: #656565;
            p::before {
              display: inline-block;
              content: "";
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #000;
              margin-right: 20px;
            }
          }
          .time {
            font-size: 12px;
            font-family: "MicrosoftYaHeiUI";
            color: #919191;
            padding-left: 25px;
          }
        }
      }
    }
  }
  .videoContent {
    width: 100%;
    border: 1px solid #d8d8d8;
    margin-top: 20px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
	&:after{
	  content:'';
	  /*这个宽度和子元素宽度一致*/
	  width: 32%;
	}
    .videoItem {
      width: 32%;
      cursor: pointer;
      video{
        width:100%;
      }
      .videoItemInfo {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        span,
        p {
          font-size: 14px;
        }
      }
    }
  }
  .zyz-recruiting{
    width: 100%;
    height: 200px;
    display: flex;
    padding: 0 10%;
    justify-content: space-between;
    .recruiting{
      width: 30%;
      background-color: rgb(226, 226, 223);
      a{
        color: white;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        div{
          font-size: 40px;
        }
      }
      .recruiting-a{
        background-color: #df9161;
      }
      .recruiting-aa{
        background-color: #df6161;
      }
    }
  }
}
</style>